import { Modal } from "semantic-ui-react";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  margin: 4rem auto !important;
`;
